import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PMWorkOrderService {
  From: any;
  To: any;
  WOHeaderData: any = { Group: '', Plant: '', FromDate: '', ToDate: '' }

  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  NotificationUrl: string = Constants.API_SIGNALR_BASE_URL;

  woStatus = [
    { id: 1, title: 'Open' },
    { id: 2, title: 'Close' },
    { id: 3, title: 'Complete' },
    { id: 4, title: 'Delay' },
    { id: 5, title: 'In Progress' },
    { id: 6, title: 'ReOpen' }
  ];

  managerData: any;

  fileteredData: any = [];
  UserData: any;
  ManagerHeaderData: any = { Group: '', Plant: '', FromDate: '', ToDate: '' }
  TechData: any;

  constructor(private http: HttpClient) { }

  setWOHeaderData(data: any) {
    this.WOHeaderData.Group = data.Group
    this.WOHeaderData.Plant = data.Plant
    this.WOHeaderData.FromDate = data.FromDate
    this.WOHeaderData.ToDate = data.ToDate
  }

  setManagerData(data: any) {
    this.managerData = data;
  }

  getManagerData() {
    return this.managerData;
  }

  getWoStatusList() {
    return this.woStatus;
  }

  getOperatorMasterData(data: any): Observable<any[]> {
    return this.http.get<any[]>(this.O3CoreApiUrl + 'PMOperatorExecution/getOperatorMasterData', { params: data });
  }

  findOperatorData(data: number): any {
    return this.http.get<any>(this.O3CoreApiUrl + 'PMOperatorExecution/showOperExecWO', { params: { WOId: data } });
  }

  createWorkOrder(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PMOperatorExecution/AddWO', data);
  }

  updateWorkOrder(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.O3CoreApiUrl + 'PMOperatorExecution/updateWO', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'RMDashboard/GetUnitList', data);
  }

  GetTreeMasterData(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Common/GetTreeMasterData', data);
  }

  addDepartmentWiseNotification(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Notification_Lean/AddDepartmentWiseNotifications', data);
  }

  addRoleWiseNotification(data: any): Observable<any[]> {
    return this.http.post<any>(this.NotificationUrl + 'add-notifications-rolewise', data);
  }

  addUserWiseNotification(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Notification_Lean/AddUserWiseNotifications', data);
  }
}
